<template>
  <div class="container">
    <div class="banner_wrapper">
      <div class="banner_img_content">
        <img class="banner_img" src="@/assets/images/about_us.png" alt="Banner" />
      </div>
      <div class="banner_content">
        <div class="banner_border"></div>
        <div class="banner_tag">
          <div class="title">About Us</div>
          <div class="description">
            Introduction to the GFF Foundation
          </div>
        </div>
      </div>
    </div>
    <div class="welfare_wrapper">
      <div class="welfare_content">
        <div class="welfare_img_div">
          <div class="welfare_img_group">
            <img src="@/assets/images/welfare_img1.svg" alt="Welfare Image" />
            <img src="@/assets/images/welfare_img2.svg" alt="Welfare Image" />
          </div>
          <div class="welfare_img_group">
            <img src="@/assets/images/welfare_img3.svg" alt="Welfare Image" />
          </div>
        </div>
        <div class="welfare_info">
          <div class="title">Background of GFF's Ministries</div>
          <div class="description">
            <p>
              The Gleaning Fields Foundation (GFF) was established in 2009. In light of the fact that many pastors and
              ministers in China have abandoned and left the pastoral and missionary ministries called by God due to
              financial hardships, God granted the vision to found GFF: to re-equip these pastors and ministers through
              comprehensive theological training and provide them with appropriate financial support, enabling them to
              return to pastoral and missionary service.
            </p>
            <p>
              In 2011, Elder Wang Chaomin was invited to serve as a director of GFF and a permanent lecturer for
              theological training. Under God’s guidance, he launched training ministries in Southeast Asia and Taiwan,
              integrating these regions with the missionary service areas he had been working in for 25 years in Africa
              and Europe. Thus, by the grace of God, GFF has gradually developed into an international missionary
              training organization.
            </p>
            <p>
              To date, GFF has proclaimed the gospel of the Kingdom of God, planted churches, trained full-time pastors/
              ministers and lay leadership teams in churches, and actively participated in humanitarian relief efforts
              in dozens of countries across Europe, Asia and Africa.
            </p>
          </div>
        </div>
        <div class="welfare_info welfare_info2">
          <div class="title">GFF's Core Bible Verses</div>
          <div class="description">
            <p>
              Matthew 28 19 Therefore go and make disciples of all nations, baptizing them in the name of the Father and
              of the Son and of the Holy Spirit, 20 and teaching them to obey everything I have commanded you. And
              surely I am with you always, to the very end of the age
            </p>
            <p>
              Acts 1:8 But you will receive power when the Holy Spirit comes on you; and you will be my witnesses in
              Jerusalem, and in all Judea and Samaria, and to the ends of the earth.”
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="teams_wrapper">
      <div class="title">Our Team</div>
      <div class="teams_content">
        <div v-for="(data, index) in aboutUsList" class="teams" :key="index">
          <img class="avatar" :src="data.avatarUrl" alt="Team Member " />
          <div class="name">{{ data.name }}</div>
          <div class="description">
            {{ data.describe }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { LoadingOutlined } from '@ant-design/icons-vue';
import { message } from 'ant-design-vue';
import { computed, ref, reactive, onMounted, toRaw, h, nextTick, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';

import { fetchHomeAboutUsList } from '@/api/common';

const route = useRoute();
const store = useStore();

const aboutUsList = ref([]);
const getAboutUsList = () => {
  fetchHomeAboutUsList().then((res) => {
    if (res.code == 200) {
      aboutUsList.value = res.data;
    }
  });
};

onMounted(() => {
  getAboutUsList();
});
</script>

<style lang="less"></style>

<style lang="less" scoped>
.container {
  .banner_wrapper {
    position: relative;
    margin: 0 auto;
    max-width: 1920px;
    max-height: 500px;
    .banner_img_content {
      padding-bottom: calc(100% * (20 / 192));
      min-height: 200px;
      .banner_img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .banner_content {
      width: 1080px;
      margin: 0 auto;
      position: absolute;
      left: calc(50% - 540px);
      top: 0;
      bottom: 0;
      display: flex;
      align-items: center;
      .banner_border {
        width: 150px;
        height: 150px;
        border: 6px solid #f78335;
      }
      .banner_tag {
        color: #fff;
        position: absolute;
        left: 60px;
        background: rgba(0, 0, 0, 0.25);
        width: 320px;
        padding: 12px 24px;
        letter-spacing: 2px;
        .title {
          font-size: 24px;
          font-weight: bold;
          margin-bottom: 10px;
        }
        .description {
          font-size: 18px;
        }
      }
    }
    @media (max-width: 1080px) {
      .banner_content {
        width: 100%;
        left: 0;
      }
    }
  }
  .welfare_wrapper {
    background: #f7f7f7;
    .welfare_content {
      width: 1080px;
      margin: 0 auto;
      display: flex;
      padding: 80px 0;
      flex-wrap: wrap;
      .welfare_img_div {
        width: 380px;
        .welfare_img_group {
          img {
            @supports (-webkit-transform-style: preserve-3d) {
              &:hover {
                -webkit-transform: translateY(-2px);
                transform: translateY(-2px);
              }
            }
          }
          &:first-child {
            display: flex;
            gap: 20px;
            margin-bottom: 20px;
            img {
              flex: (100% - 20px) / 2;
            }
          }
          &:last-child {
            img {
              width: 100%;
            }
          }
        }
      }
      .welfare_info {
        flex: 1;
        padding-left: 40px;
        display: flex;
        align-content: center;
        flex-wrap: wrap;
        .title {
          font-size: 28px;
          font-weight: bold;
          margin-bottom: 20px;
        }
        .description {
          font-size: 16px;
          line-height: 1.6;
        }
      }
      .welfare_info2 {
        flex: 100%;
        margin-top: 50px;
        padding-left: 0;
      }
    }
    @media (max-width: 1080px) {
      .welfare_content {
        width: 100%;
        padding: 20px;
        .welfare_img_div {
          flex: 100%;
          margin: 20px auto;
        }
        .welfare_info {
          padding: 16px;
        }
      }
    }
  }
  .teams_wrapper {
    width: 1080px;
    margin: 0 auto;
    .title {
      font-size: 28px;
      font-weight: bold;
      margin: 40px 0;
      text-align: center;
    }
    .teams_content {
      display: flex;
      margin-top: 160px;
      gap: 40px;
      flex-wrap: wrap;
      .teams {
        margin-bottom: 100px;
        width: calc((100% - 120px) / 4);
        background: #f7f7f7;
        box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
        border-radius: 16px;
        position: relative;
        padding: 80px 24px 24px;
        cursor: pointer;
        .avatar {
          width: 160px;
          height: 160px;
          border-radius: 50%;
          position: absolute;
          top: -80px;
          left: calc(50% - 80px);
        }
        .name {
          font-size: 20px;
          font-weight: bold;
          margin-top: 15px;
          text-align: center;
        }
        .description {
          margin-top: 10px;
          line-height: 28px;
          font-size: 14px;
        }
        &:hover {
          background: #eb8540;
          color: #ffffff;
          .avatar {
            border: 6px solid #eb8540;
          }
        }
      }
    }
  }
  @media (max-width: 1080px) {
    .teams_wrapper {
      width: 100%;
      gap: 20px;
      padding: 20px;
      .teams_content {
        .teams {
          width: calc(50% - 20px);
          .name {
            margin-top: 8px;
          }
        }
      }
    }
  }
}
</style>
